import React, { useEffect } from 'react'
import sessionUtils from '../../data/session-utils'

import useOrder from '../../data/useOrder'
import { OrderState } from '../../typings/Order'

import { ConfirmationOrderDocument, ConfirmationOrderQuery } from '../../graphql'
import ConfirmationComponent from './ConfirmationComponent'

import ConfirmationSkeleton from './Skeletons/SkeletonConfirmation'

const Confirmation: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { orderData, isOrderLoading } = useOrder<ConfirmationOrderQuery>(ConfirmationOrderDocument)

  useEffect(() => {
    sessionUtils.removeStepper()
    sessionUtils.setConfirmationWasSuccessful()
  }, [])

  if (!orderData || isOrderLoading) {
    return <ConfirmationSkeleton />
  }

  const isOrderConfirmed = orderData.order.state === OrderState.ORDER_STATE_CONFIRMED
  const bookingOrderItem = orderData.order.items.find((item) => item.__typename === 'BookingOrderItem')
  const wasSomethingPayed = Boolean(orderData.order.amount.value)
  const invoiceDownloadLink = orderData.order.invoice && orderData.order.invoice.downloadLink
  const voucherCode =
    (orderData.order.items[0].__typename === 'AssignedProductOrderItem' &&
      orderData.order.items[0].assignedProduct.__typename === 'AssignedVoucher' &&
      orderData.order.items[0].assignedProduct.code) ||
    undefined
  const customer = orderData.order.customer
  const eventId = bookingOrderItem
    ? bookingOrderItem.__typename === 'BookingOrderItem' &&
      bookingOrderItem.booking.__typename === 'EventBooking' &&
      bookingOrderItem.booking.bookableItem.id
    : undefined

  return (
    <ConfirmationComponent
      venue={orderData.order.venue}
      eventId={eventId || undefined}
      isOrderConfirmed={isOrderConfirmed}
      hasBooking={Boolean(bookingOrderItem)}
      hasSelfCheckIn={orderData.order.isSelfCheckinAvailable}
      invoiceDownloadLink={invoiceDownloadLink}
      wasSomethingPayed={wasSomethingPayed}
      voucherCode={voucherCode}
      customer={customer}
    />
  )
}

export default Confirmation
